/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import type { ApiResponsePlural } from 'flarum/common/Store';
import type Discussion from 'flarum/common/models/Discussion';

export default class HomeDiscussionsState extends DiscussionListState {
	pageSize: number;

	constructor(params: any, page: number, pageSize: number) {
		super(params, page);

		// DiscussionListState doesn't allow passing of pageSize
		// so we need to set it here explicitly
		this.pageSize = pageSize;
	}

	requestParams() {
		const original = super.requestParams();
		return {
			...original,
			filter: { language: app.translator.getLocale(), ...(this.params.filter || {}) },
			sort: this.params.sort ? this.params.sort : '-lastPostedAt',
			page: { offset: 0, limit: this.pageSize },
			include: [...(original.include || []), ...(this.params.include || [])],
		};
	}

	protected loadPage(page = 1): Promise<ApiResponsePlural<Discussion>> {
		const params: any = this.requestParams();
		params.page = {
			offset: this.pageSize * (page - 1),
			...params.page,
		};

		if (Array.isArray(params.include)) {
			params.include = params.include.join(',');
		}

		return app.store.find(this.type, params) as unknown as Promise<ApiResponsePlural<Discussion>>;
	}
}
